<template>
  <div class="select-layout">
    <header class="select-header">
      <a href="/">
        <img
          class="select-marca"
          src="@/assets/img/logo-onyxerp-invertido.svg"
          alt="Marca"
        />
        <br />
      </a>
      <span class="tagline">Soluções modernas para o serviço público</span>
    </header>
    <main class="select-content">
      <slot></slot>
    </main>
    <footer class="select-footer">
      <div class="footer-logos">
        <a href="https://www.braconsultoria.com.br/">
          <img src="@/assets/img/bra_logo_branco.svg" alt="Bra Logo" width="80">
        </a>
      </div>
      <p class="copyright">© {{ year }} OnyxERP. Todos os direitos reservados.</p>
    </footer>
  </div>
</template>

<script>
export default {
  name: "SelectLayout",
  data() {
    return {
      year: new Date().getFullYear()
    }
  }
}
</script>

<style scoped>
.select-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 24px 5%;
  background: #1c1c1c;
  color: #fff;
}

.select-header {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
}

.select-marca {
  height: 40px;
  width: auto;
  max-width: 100%;
}

@media only screen and (max-width: 480px) {
  .select-marca {
    height: 32px;
  }
}

.select-header .tagline {
  font-size: 12px;
  margin-bottom: 10px;
  color: #ccc;
}

.select-content {
  width: 100%;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.select-footer {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.footer-logos {
  display: flex;
  gap: 40px;
}

.footer-logos img {
  max-width: 80px;
  height: auto;
}

.copyright {
  font-size: 12px;
  color: #ccc;
  margin: 0;
}
</style>
